/**
 * Authentication Types
 * Types and enums for authentication flow
 */

export enum AuthModalState {
  Initial = 'initial',           // Show auth form
  EmailSent = 'email-sent',      // Magic link sent confirmation
  ActivationComplete = 'activation-complete', // New user activated account
  Error = 'error'                // Error state
}

/**
 * Verdict on a single access-token refresh attempt. Only `Terminal` may end a
 * session — see `lib/authTokenRefresh.ts`.
 */
export enum AuthRefreshOutcome {
  /** A new access token is in hand. */
  Refreshed = 'refreshed',
  /** Failed for a reason that may not fail again. Session preserved. */
  Transient = 'transient',
  /** The refresh token is definitively dead. */
  Terminal = 'terminal',
  /**
   * There was no session to refresh. Distinct from `Terminal`: nothing died, so
   * nobody gets signed out — the app is simply already signed out.
   */
  NoSession = 'no_session',
}

export interface AuthError {
  title: string;
  message: string;
  action?: string;
}


